import { render, staticRenderFns } from "./TareasTable.vue?vue&type=template&id=5f856438&"
import script from "./TareasTable.vue?vue&type=script&lang=js&"
export * from "./TareasTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QToolbar,QToolbarTitle,QSpace,QBtn,QTable,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QToolbar,QToolbarTitle,QSpace,QBtn,QTable,QTd})
